var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(46.2051 46.7734) rotate(-180)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9171",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "46.2051",
              y: "46.7734",
              width: "46",
              height: "46",
              rx: "6",
              transform: "rotate(-180 46.2051 46.7734)",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9171)" } }, [
        _c("path", {
          attrs: {
            d: "M0.220402 46.7734H46.2051V0.773438H0.220402V46.7734Z",
            fill: "#CE388A",
          },
        }),
        _c("path", {
          attrs: {
            d: "M22.875 46.7734H0.206472V24.254C12.7256 24.254 22.875 34.3367 22.875 46.7734Z",
            fill: "#E781C0",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }